import React from 'react';

import { EditContactDialog } from '~/components/Contacts/UpsertContact/Edit/EditContactDialog';
import useFetchContact from '~/components/hooks/useFetchContact';
import LoadingIndicator from '~/components/LoadingIndicator';

interface ContactFinanceEditDialogProps {
  contactId: number;
  onClose: () => void;
  onSave: () => void;
}

const ContactFinanceEditDialog: React.FC<ContactFinanceEditDialogProps> = ({ contactId, onClose, onSave }) => {
  const { isLoading, isError, data: contact } = useFetchContact(contactId);

  if (isLoading || !contact) {
    return <LoadingIndicator isError={isError} />;
  }

  const handleContactUpdate = () => {
    onSave();
    return Promise.resolve();
  };

  return (
    <EditContactDialog
      contact={contact}
      onClose={onClose}
      onContactUpdate={handleContactUpdate}
      title="Contact Finance Details"
      initialTabKey="finance"
    />
  );
};

export default ContactFinanceEditDialog;
